import molin_20 from '../../assets/images/tra/molin_20.webp';
import molin_21 from '../../assets/images/tra/molin_21.webp';
import molin_22 from '../../assets/images/tra/molin_22.webp';
import molin_23 from '../../assets/images/tra/molin_23.webp';
import molin_24 from '../../assets/images/tra/molin_24.webp';
import molin_25 from '../../assets/images/tra/molin_25.webp';
import MolinHeader from '../../components/MolinHeader';
import { useState } from 'react';
import '../../styles/common.css'
export default function AppraisalHall() {
    const [storyStatus, setStoryStatus] = useState(0);
    return (
        <div className="relative">
            <MolinHeader></MolinHeader>

            {storyStatus === 0 && (
                <div>
                    <img src={molin_20} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[41.5%] absolute left-[35.5%] w-[26%] z-[9999] text-left">
                        <div className="flex flex-col">
                            <span className='text-[#000000] text-[2.1vw]' style={{ display: 'block' }}>项</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.8vw]" style={{ display: 'block' }}>氏</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.5vw]" style={{ display: 'block' }}>鉴</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.6vw]" style={{ display: 'block' }}>古</span>
                            <span className="text-[#000000] text-[2.1vw] mt-[-0.8vw]" style={{ display: 'block' }}>堂</span>
                            <span className="text-[#000000] text-[0.8vw]" style={{ display: 'block' }}>Xiang's</span>
                            <span className="text-[#000000] text-[0.8vw] mt-[-0.4vw] ml-[-1.2vw]" style={{ display: 'block' }}>Appraisal Hall</span>
                        </div>
                    </div>
                    <div className="top-[36%] absolute left-[40.5%] w-[25%] z-[9999] text-justify">
                        <div className="flex flex-col">
                            <span className="text-[#000000] text-[0.7vw] mt-[5.4vw] leading-[1.1vw]">明代中后期，随着商品经济的发展，典当行业成为富商积累资本的重要手段。项元汴家族因经营质舍业而“富甲三吴”（《明史·食货志》），其当铺不仅提供资金周转服务，还通过收购当物扩大收藏规模。项元汴的当铺并非单纯牟利，而是通过典当业务筛选优质书画，“项氏质舍，以书画为重，凡遇名迹，必重价收之，久而自成巨藏。”（《石渠宝笈·续编》）</span>
                            <span className="text-[#000000] text-[0.6vw] mt-[0.8vw] leading-[0.8vw]">In the middle to late Ming Dynasty, with the development of the commodity economy, the pawn industry became a crucial means for wealthy merchants to accumulate capital. The Xiang family, through their pawnshops, achieved the status of being "the richest in the Three Wu regions" (History of the Ming Dynasty: Annals of Finance and Economy). Their pawnshops not only provided financial services for short-term loans but also expanded their art collection by acquiring pledged items. Xiang Yuanbian's pawnshops were not merely profit-driven; instead, they selectively acquired high-quality calligraphy and paintings through pawn transactions. As recorded in The Stone Channel Imperial Catalogue: Supplementary Volume, "The Xiang family pawnshops prioritized calligraphy and painting. Whenever they encountered renowned works, they would pay a premium price to acquire them, eventually amassing a vast collection."</span>
                        </div>
                    </div>
                    <div className='absolute bottom-[21%] left-[45%] h-auto w-[10vw] transition-transform duration-300 hover:scale-110 cursor-pointer animate-breathe-enter'
                        onClick={() => setStoryStatus(1)}>
                        <div className="flex flex-col text-center">
                            <span className="text-[#000000] text-[1.3vw]">进入</span>
                            <span className="text-[#000000] text-[1vw]">Enter</span>
                        </div>
                    </div>
                </div>
            )}
            {storyStatus === 1 && (
                <div>
                    <img src={molin_21} alt="Hero background" className="w-full h-auto" />
                    <div className="bottom-[32%] left-[45%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(2)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 2 && (
                <div>
                    <img src={molin_22} alt="Hero background" className="w-full h-auto" />
                    <div className="top-[62%] left-[25%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(3)}>
                        </button>
                    </div>
                    <div className="top-[62%] left-[65%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(6)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 3 && (
                <div className="bottom-[30%] left-[40%] absolute">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(4)}>
                    </button>
                </div>
            )}

            {storyStatus >= 3 && storyStatus < 6 && (
                <div>
                    <img src={molin_23} alt="Hero background" className="w-full h-auto" />
                    <div className="bottom-[28%] left-[68%] absolute z-[9999]">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(2)}>
                        </button>
                    </div>
                </div>
            )}
            {storyStatus === 4 && (
                <div className="top-[35%] left-[53%] absolute z-[9999]">
                    <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                        onClick={() => setStoryStatus(5)}>
                    </button>
                </div>
            )}
            {storyStatus >= 4 && storyStatus < 6 && (
                <div>
                    <div className="bottom-[10%] left-0 absolute w-full h-auto">
                        <img src={molin_25} alt="Hero background" className="w-full h-auto" />
                    </div>
                    <div className='absolute bottom-[10%] left-[50%] h-[6vw] w-[10vw] transition-transform duration-300 hover:scale-110'>
                        <div className="flex flex-col text-center font-bold">
                            <span className="text-[#000000] text-[1vw]">项元汴</span>
                            <span className="text-[#000000] text-[0.8vw]">Xiang Yuanbian</span>
                        </div>
                    </div>
                    <div className={`chat-bubble-base absolute bottom-[35%] left-[80%] transform -translate-x-1/2 chat-bubble-left
                        chat-bubble-fade-in ${storyStatus >= 4 ? 'chat-bubble-fade-in-active' : ''}`}>
                        <span className='mt-[1vw] typing-effect'>此物釉色青白如冰，胎质细腻如玉，乃是宋代影青瓷中的上品，实乃稀世之珍</span>
                        <span className='typing-effect'>This piece boasts a glaze as clear and pale as ice, with a porcelain body as fine as jade. It is a </span>
                        <span className='mb-[1vw] typing-effect'>masterpiece of Song dynasty celadon porcelain, a truly rare treasure.</span>
                    </div>
                </div>
            )}
            {storyStatus === 5 && (
                <div className={`chat-bubble-base absolute top-[30%] left-[50%] transform -translate-x-1/2 chat-bubble-right
                    chat-bubble-fade-in ${storyStatus >= 5 ? 'chat-bubble-fade-in-active' : ''}`}>
                    <span className='mt-[1vw] typing-effect'>“这尊瓷器，原是一位文人因家道艰难，不得已典当而来。我虽心生怜悯，却更惜此物之美，</span>
                    <span className='typing-effect'>便允诺重金典当，约定三月后赎回。后得知其已离世，便将其收入天籁阁中。”</span>
                    <span className='typing-effect'>This porcelain piece originally came to me when a scholar, burdened by family hardship, was forced to pawn it. Though I felt compassion for </span>
                    <span className='typing-effect'>his plight, I was even more captivated by the beauty of the piece and offered a generous sum to pawn it, agreeing that he could redeem it </span>
                    <span className='typing-effect'>within three months. Later, I learned of his passing and, unable to return the treasure to its rightful owner, incorporated it into my </span>
                    <span className='mb-[1vw] typing-effect'>Tianlai Pavilion collection.</span>

                </div>
            )}
            {storyStatus === 6 && (
                <div>
                    <img src={molin_24} alt="Hero background" className="w-full h-auto" />
                    <div className="bottom-[25%] left-[35%] absolute">
                        <button className="rounded-full breathe-l bg-transparent animate-breathe shadow-lg transition-all cursor-pointer"
                            onClick={() => setStoryStatus(2)}>
                        </button>
                    </div>
                </div>

            )}
        </div>
    )
}